<template>
  <div>
    {{label}}
  </div>
</template>

<script>
export default {
  name: 'TabBox',
  props: ['label','icon']
}
</script>

<style lang="scss">
	@import '../styling/global_vars';



</style>



// WEBPACK FOOTER //
// TabBox.vue?293fd662